import script from "./NoticeDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoticeDetail.vue?vue&type=script&setup=true&lang=ts"

import "./NoticeDetail.vue?vue&type=style&index=0&id=7d7b7752&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d7b7752"]])

export default __exports__